// Keeps PrimeVue's built-in strings in step with the vue-i18n locale.
//
// PrimeVue ships English only: DatePicker's month/day names, `dateFormat`
// (mm/dd/yy) and first day of the week, Password's "Enter a password" prompt,
// Listbox/MultiSelect's "{0} items selected", the aria labels of every component.
// Until now nothing synced them with the UI language, so an Italian UI showed
// English dates. The translations come from PrimeTek's own `primelocale` package.
//
// Install AFTER `app.use(PrimeVue, …)`: it writes `$primevue.config.locale`
// (reactive) and follows every later `locale.value = lang` switch.
import { watch } from 'vue';
import { it } from 'primelocale/js/it.js';
import { en } from 'primelocale/js/en.js';

const PRIME_LOCALES = { it, en };

/** @returns the primelocale bundle for a vue-i18n locale code, English when unknown. */
export function primeVueLocaleFor(lang) {
  return PRIME_LOCALES[lang] ?? en;
}

export default {
  install(app, { i18n }) {
    const primevue = app.config.globalProperties.$primevue;
    if (!primevue) {
      throw new Error('PrimeVueLocaleSync must be installed after PrimeVue');
    }
    const apply = (lang) => {
      primevue.config.locale = primeVueLocaleFor(lang);
    };
    apply(i18n.global.locale.value);
    watch(i18n.global.locale, apply);
  },
};
